import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import { defaultSelectedSupplier } from '../../InvoiceScanManagerContext';

const SelectPoActionCell = (props: GridCellProps) => {
  const {
    setPoNumber,
    closePoMatchModal,
    previewDocument,
    getPoValidations,
    onlineOfflineSuppliers,
    setSelectedSupplier,
  } = useInvoiceScanManager();
  const field = props.field || '';
  const isDisabled = !props.dataItem[field];
  const { supplierId, poNumber, poId } = props.dataItem;

  const errorHoverMessage = useMemo(() => {
    if (isDisabled) {
      return [
        'You cannot select an invalid PO (PO is new, closed, cancelled, submitted, no access or exists in other company).',
      ];
    }
    return [];
  }, [isDisabled]);

  const handleSelectPo = useCallback(async () => {
    closePoMatchModal();
    const poMatchedSupplier = onlineOfflineSuppliers.find((item) => item.supplierId === supplierId);
    setSelectedSupplier(poMatchedSupplier ? poMatchedSupplier : defaultSelectedSupplier);
    await getPoValidations(previewDocument?.attachId as number, poNumber, poId);
    setPoNumber((prevState) => ({
      ...prevState,
      value: poNumber,
    }));
  }, [
    closePoMatchModal,
    onlineOfflineSuppliers,
    setSelectedSupplier,
    getPoValidations,
    previewDocument?.attachId,
    poNumber,
    poId,
    setPoNumber,
    supplierId,
  ]);

  return (
    <GridCellBase
      {...props}
      title="Select PO"
      rowSelectionEnabled={false}
      disableToolTip={isDisabled}
    >
      <div className="flex justify-center items-center">
        <PopUp
          content={
            <div className="m-1 max-w-[300px]">
              <PopUpContentWrapper type="Error" contents={errorHoverMessage} />
            </div>
          }
          show={isDisabled}
        >
          <Button color="info" onClick={handleSelectPo} disabled={isDisabled} size="sm">
            Select PO
          </Button>
        </PopUp>
      </div>
    </GridCellBase>
  );
};

export default SelectPoActionCell;
